import React from 'react';
import Tooltip from '@/components/Tooltip';
import OpenAILogo from '@/components/icons/OpenAILogo';

// KeyStatTooltipContent helper component for tooltips
const KeyStatTooltipContent: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="w-64 p-2 text-xs font-mono">
    {children}
  </div>
);

// StatCard component to standardize the stat block appearance
const StatCard: React.FC<{
  title: string;
  value: string;
  footer: string;
  tooltipContent: React.ReactNode;
  isOpenBrain?: boolean;
}> = ({ title, value, footer, tooltipContent, isOpenBrain = false }) => (
  <Tooltip content={<KeyStatTooltipContent>{tooltipContent}</KeyStatTooltipContent>}>
    <div className={`px-4 py-2 rounded-md h-full ${isOpenBrain ? "bg-[var(--accent)] text-white" : "border border-black"} relative`}>
      {isOpenBrain && (
        <div className="absolute top-2 right-2">
          <OpenAILogo size={20} color="white" />
        </div>
      )}
      <div className={`text-[10px] uppercase mb-1 ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{title}</div>
      <div className="text-2xl font-bold">{value}</div>
      <div className={`text-[10px] ${isOpenBrain ? "text-white" : "text-gray-500"}`}>{footer}</div>
    </div>
  </Tooltip>
);

const KeyMetrics2026: React.FC = () => {
  return (
    <div className="font-mono mt-8 mb-8">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* Global AI Title + First Stat */}
        <div className="order-10 lg:order-none">
          <StatCard 
            title="CAPEX GLOBALE PER L’IA"
            value="$1.000 mld"
            footer="COSTO TOTALE DI POSSESSO DELLE RISORSE DI CALCOLO ATTIVE"
            tooltipContent={"Investimenti globali nelle infrastrutture di IA"}
          />
        </div>

        {/* Title - spans 2 columns */}
        <div className="col-span-2">
          <h2 className="text-[40px] font text-right not-italic mt-0 mb-0 font-bold font-sans tracking-tight uppercase">METRICHE CHIAVE 2026</h2>
          {/* <h3 className="text-xl font-bold mb-4 uppercase italic bg-[var(--accent)] text-white inline-block px-2 py-1">OPENMIND</h3> */}
        </div>

        {/* Global AI stats - row 2 */}
        <div className="order-11 lg:order-none">
          <StatCard 
            title="POTENZA ELETTRICA GLOBALE DELL'IA"
            value="38 GW"
            footer="POTENZA DI PICCO"
            tooltipContent={"Picco globale di potenza elettrica assorbita dai sistemi di IA"}
          />
        </div>
        
        {/* OpenBrain stats - row 1, columns 1-2 */}
        <div className="order-1 lg:order-none">
          <StatCard 
            title="RICAVI DI OPENBRAIN"
            value="$35 mld"
            footer="ANNO 2026"
            tooltipContent={"Ricavi annuali previsti di OpenBrain per il 2026."}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-2 lg:order-none">
          <StatCard 
            title="SPESE IN CONTO CAPITALE"
            value="$200 mld"
            footer="COSTO DI POSSESSO DELLE RISORSE DI CALCOLO ATTIVE DI OPENBRAIN"
            tooltipContent={"Investimenti totali per l’infrastruttura di calcolo di OpenBrain."}
            isOpenBrain={true}
          />
        </div>

        {/* Global AI stats - row 3 */}
        <div className="order-12 lg:order-none">
          <StatCard 
            title="QUOTA DELLA POTENZA ELETTRICA STATUNITENSE PER L’IA"
            value="2,5%"
            footer="33 GW SU 1,34 TW DI CAPACITÀ"
            tooltipContent={"Percentuale della capacità elettrica statunitense utilizzata per le operazioni di IA."}
          />
        </div>
        
        
        
        {/* OpenBrain stats - row 2, columns 1-2 */}
        <div className="order-3 lg:order-none">
          <StatCard 
            title="COSTI DI CALCOLO DI OPENBRAIN"
            value="$40 mld"
            footer="ANNO 2026"
            tooltipContent={"Costi annuali delle risorse di calcolo per le operazioni di OpenBrain."}
            isOpenBrain={true}
          />
        </div>
        
        <div className="order-4 lg:order-none">
          <StatCard 
            title="FABBISOGNO DI POTENZA ELETTRICA DI OPENBRAIN"
            value="6 GW"
            footer="POTENZA DI PICCO"
            tooltipContent={"Fabbisogno di potenza di picco DELl’infrastruttura di calcolo di OpenBrain."}
            isOpenBrain={true}
          />
        </div>
        
        
        
        
      </div>
    </div>
  );
};

export default KeyMetrics2026;
